import moment from "moment";
import dayjs from "dayjs";
dayjs.extend(require("dayjs/plugin/utc"));

export const getFileType = (fileName) => {
  if (!fileName) return "unknown";

  const lower = fileName.toLowerCase();

  // Handles "PHOTO123.application/pdf" pattern from your S3 keys
  if (lower.includes("application/pdf")) return "pdf";

  // Handles "PHOTO123.image/jpeg" or standard ".jpg" extensions
  if (lower.includes("image/")) return "image";
  if (lower.match(/\.(jpg|jpeg|png|gif|webp|bmp)$/)) return "image";

  // Standard extension fallback
  if (lower.endsWith(".pdf")) return "pdf";

  return "unknown";
};

export const convertUTCDateLocal = (utcDate, format) => {
  if (!format) {
    format = "DD/MM/YYYY HH:mm:ss";
  }

  // Convert UTC date to local date and time
  console.log(" utc ",utcDate);
  // const localDate = moment.utc(utcDate).local();
  const localDate = dayjs.utc(utcDate).local();
  console.log(" localDate ",localDate);

  return localDate.format(format);
};

export const convertUTCDate = (date, format) => {
  if (!format) {
    var d = new Date();
    date = new Date(
      dayjs(date, "MM-DD-YYYY").format("MM/DD/YYYY") +
        " " +
        d.getHours() +
        ":" +
        d.getMinutes(),
    );
  }
  format = format || "MM/DD/YYYY";
  return dayjs(date).utc().format(format);
};

export const convertToUTCDate = (date, format = "YYYY-MM-DD HH:mm:ss") => {
  if (!date) return null;
  return dayjs(date).utc().format(format);
};

export const convertFromUTCDate = (date, format = "YYYY-MM-DD HH:mm:ss") => {
  if (!date) return null;
  return dayjs.utc(date).local().format(format);
};

export const ConvertTime = (time) => {
  const timePart = time.format("HH:mm");
  return `${timePart}`;
};

export const convertDate = (date) => {
  const datePart = dayjs(date, "MM-DD-YYYY").format("MM/DD/YYYY");
  const time = `${datePart}`;
  return time;
};

export const filterValidValues = (obj) => {
  return Object.fromEntries(
    Object.entries(obj).filter(
      ([_, value]) => value !== undefined && value !== null && value !== "",
    ),
  );
};

export const calculateAge = (dob) => {
  const dobData = dob;
  const dobYear = dobData?.split("/")[2];
  const currYear = new Date().getFullYear();
  if (dobYear) {
    const patientAge = currYear - Number(dobYear);
    return patientAge;
  }
};

export const POSTAL_CODE_REGEX = {
  // ASIA
  IN: /^[1-9][0-9]{5}$/, // India
  MY: /^\d{5}$/, // Malaysia
  SG: /^\d{6}$/, // Singapore
  TH: /^\d{5}$/, // Thailand
  ID: /^\d{5}$/, // Indonesia
  PH: /^\d{4}$/, // Philippines
  JP: /^\d{3}-?\d{4}$/, // Japan
  KR: /^\d{5}$/, // South Korea
  CN: /^\d{6}$/, // China
  PK: /^\d{5}$/, // Pakistan
  BD: /^\d{4}$/, // Bangladesh
  LK: /^\d{5}$/, // Sri Lanka
  AE: null, // UAE (no postal code)
  HK: null, // Hong Kong (no postal code)

  // NORTH AMERICA
  US: /^\d{5}(-\d{4})?$/, // USA
  CA: /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/, // Canada
  MX: /^\d{5}$/, // Mexico

  // EUROPE
  UK: /^[A-Za-z]{1,2}\d[A-Za-z\d]?\s?\d[A-Za-z]{2}$/,
  DE: /^\d{5}$/, // Germany
  FR: /^\d{5}$/, // France
  IT: /^\d{5}$/, // Italy
  ES: /^\d{5}$/, // Spain
  NL: /^\d{4}\s?[A-Za-z]{2}$/, // Netherlands
  BE: /^\d{4}$/, // Belgium
  CH: /^\d{4}$/, // Switzerland
  AT: /^\d{4}$/, // Austria
  SE: /^\d{3}\s?\d{2}$/, // Sweden
  NO: /^\d{4}$/, // Norway
  DK: /^\d{4}$/, // Denmark
  FI: /^\d{5}$/, // Finland
  IE: /^[A-Za-z]\d{2}\s?[A-Za-z\d]{4}$/, // Ireland (Eircode)
  PL: /^\d{2}-\d{3}$/, // Poland
  PT: /^\d{4}-\d{3}$/, // Portugal
  CZ: /^\d{3}\s?\d{2}$/, // Czech Republic
  HU: /^\d{4}$/, // Hungary
  RO: /^\d{6}$/, // Romania
  GR: /^\d{3}\s?\d{2}$/, // Greece

  // OCEANIA
  AU: /^\d{4}$/, // Australia
  NZ: /^\d{4}$/, // New Zealand

  // SOUTH AMERICA
  BR: /^\d{5}-?\d{3}$/, // Brazil
  AR: /^[A-Za-z]\d{4}[A-Za-z]{3}$/, // Argentina
  CL: /^\d{7}$/, // Chile
  CO: /^\d{6}$/, // Colombia
  PE: /^\d{5}$/, // Peru

  // AFRICA
  ZA: /^\d{4}$/, // South Africa
  NG: /^\d{6}$/, // Nigeria
  KE: /^\d{5}$/, // Kenya
  EG: /^\d{5}$/, // Egypt
};

export const validatePostalCode = (countryCode, value) => {
  const regex = POSTAL_CODE_REGEX[countryCode];

  // Countries without postal codes
  if (regex === null) return true;

  // Unknown country → allow but limit length
  if (!regex) return value.length <= 10;

  return regex.test(value);
};

// ==================== CURRENCY CONFIG ====================
// 👇 Change this ONE value to update currency across the entire app
const loggedUserObj = sessionStorage.getItem('login_result');
const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;

export const APP_CURRENCY = loggedUser?.user?.currencyCode;

// Full currency map — switch APP_CURRENCY above to change globally
export const CURRENCY_CODES = {
  // ASIA
  IN:  { code: "INR", symbol: "₹", name: "Indian Rupee" },
  MY:  { code: "MYR", symbol: "RM", name: "Malaysian Ringgit" },
  SG:  { code: "SGD", symbol: "S$", name: "Singapore Dollar" },
  TH:  { code: "THB", symbol: "฿", name: "Thai Baht" },
  ID:  { code: "IDR", symbol: "Rp", name: "Indonesian Rupiah" },
  PH:  { code: "PHP", symbol: "₱", name: "Philippine Peso" },
  JP:  { code: "JPY", symbol: "¥", name: "Japanese Yen" },
  KR:  { code: "KRW", symbol: "₩", name: "South Korean Won" },
  CN:  { code: "CNY", symbol: "¥", name: "Chinese Yuan" },
  PK:  { code: "PKR", symbol: "₨", name: "Pakistani Rupee" },
  BD:  { code: "BDT", symbol: "৳", name: "Bangladeshi Taka" },
  LK:  { code: "LKR", symbol: "Rs", name: "Sri Lankan Rupee" },
  AE:  { code: "AED", symbol: "د.إ", name: "UAE Dirham" },
  HK:  { code: "HKD", symbol: "HK$", name: "Hong Kong Dollar" },

  // NORTH AMERICA
  US:  { code: "USD", symbol: "$", name: "US Dollar" },
  CA:  { code: "CAD", symbol: "CA$", name: "Canadian Dollar" },
  MX:  { code: "MXN", symbol: "$", name: "Mexican Peso" },

  // EUROPE
  UK:  { code: "GBP", symbol: "£", name: "British Pound" },
  DE:  { code: "EUR", symbol: "€", name: "Euro" },
  FR:  { code: "EUR", symbol: "€", name: "Euro" },
  IT:  { code: "EUR", symbol: "€", name: "Euro" },
  ES:  { code: "EUR", symbol: "€", name: "Euro" },
  NL:  { code: "EUR", symbol: "€", name: "Euro" },
  BE:  { code: "EUR", symbol: "€", name: "Euro" },
  CH:  { code: "CHF", symbol: "Fr", name: "Swiss Franc" },
  AT:  { code: "EUR", symbol: "€", name: "Euro" },
  SE:  { code: "SEK", symbol: "kr", name: "Swedish Krona" },
  NO:  { code: "NOK", symbol: "kr", name: "Norwegian Krone" },
  DK:  { code: "DKK", symbol: "kr", name: "Danish Krone" },
  FI:  { code: "EUR", symbol: "€", name: "Euro" },
  IE:  { code: "EUR", symbol: "€", name: "Euro" },
  PL:  { code: "PLN", symbol: "zł", name: "Polish Złoty" },
  PT:  { code: "EUR", symbol: "€", name: "Euro" },
  CZ:  { code: "CZK", symbol: "Kč", name: "Czech Koruna" },
  HU:  { code: "HUF", symbol: "Ft", name: "Hungarian Forint" },
  RO:  { code: "RON", symbol: "lei", name: "Romanian Leu" },
  GR:  { code: "EUR", symbol: "€", name: "Euro" },

  // OCEANIA
  AU:  { code: "AUD", symbol: "A$", name: "Australian Dollar" },
  NZ:  { code: "NZD", symbol: "NZ$", name: "New Zealand Dollar" },

  // SOUTH AMERICA
  BR:  { code: "BRL", symbol: "R$", name: "Brazilian Real" },
  AR:  { code: "ARS", symbol: "$", name: "Argentine Peso" },
  CL:  { code: "CLP", symbol: "$", name: "Chilean Peso" },
  CO:  { code: "COP", symbol: "$", name: "Colombian Peso" },
  PE:  { code: "PEN", symbol: "S/", name: "Peruvian Sol" },

  // AFRICA
  ZA:  { code: "ZAR", symbol: "R", name: "South African Rand" },
  NG:  { code: "NGN", symbol: "₦", name: "Nigerian Naira" },
  KE:  { code: "KES", symbol: "KSh", name: "Kenyan Shilling" },
  EG:  { code: "EGP", symbol: "£", name: "Egyptian Pound" },
};

// Helper — get symbol/code for the active currency
export const getCurrencyByCode = (currencyCode = APP_CURRENCY) => {
  return Object.values(CURRENCY_CODES).find(c => c.code === currencyCode)
    || { code: currencyCode, symbol: currencyCode, name: currencyCode };
};

export const ACTIVE_CURRENCY = getCurrencyByCode(APP_CURRENCY);
// ACTIVE_CURRENCY.code   → "USD"
// ACTIVE_CURRENCY.symbol → "$"
// ACTIVE_CURRENCY.name   → "US Dollar"
